import { useNavigate, useParams } from 'react-router-dom';
import { VisitorIcon } from '@shared/assets';
import { checkEventEnd } from '@src/library/helpers/events/dateSets';
import { ButtonConnect } from '../visitor-actions/frames';
import * as st from './styles.module.scss';

interface Props {
  mode: string;
  timeEnd: string;
  count: number;
}

export const ButtonVisitors = ({ mode, timeEnd, count }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { id, code } = useParams<{ id: string; code: string }>();

  const isEventEnd = checkEventEnd(timeEnd);

  const onVisitors = () => {
    navigate(`/events/${code}/${id}/visitors`);
  };

  return (
    <>
      {!isEventEnd && mode === 'N' && <ButtonConnect />}
      <button className={st.visitors} onClick={onVisitors}>
        <div className={st.left}>
          <VisitorIcon />
        </div>
        <div className={st.right}>{count}</div>
      </button>
    </>
  );
};
